// extracted by mini-css-extract-plugin
export default {"container":"WorkflowCanvasWithLayout_container__OhhKW"};